import React from "react";
import { Header } from "../components/landing/Header";
import { Hero } from "../components/landing/Hero";
import { EditorialMarquee } from "../components/landing/EditorialMarquee";
import { TrustBanner } from "../components/landing/TrustBanner";
import { Manifesto } from "../components/landing/Manifesto";
import { Services } from "../components/landing/Services";
import { Testimonials } from "../components/landing/Testimonials";
import { Gallery } from "../components/landing/Gallery";
import { FAQ } from "../components/landing/FAQ";
import { QuoteForm } from "../components/landing/QuoteForm";
import { Footer } from "../components/landing/Footer";
import { FloatingCTA } from "../components/landing/FloatingCTA";

export default function Home() {
  return (
    <div className="relative overflow-x-hidden" data-testid="home-page">
      <Header />
      <main>
        <Hero />
        <EditorialMarquee />
        <TrustBanner />
        <Services />
        <Manifesto />
        <Gallery />
        <Testimonials />
        <FAQ />
        <QuoteForm />
      </main>
      <Footer />
      <FloatingCTA />
    </div>
  );
}
